import dayjs from "dayjs";
import { dateRange } from '../state';
import { fetchAnalyticsData } from './fetchAnalyticsData';

/**
 * Tarih aralığını temizleme fonksiyonu
 * @param {string} assetId - Asset ID
 */
export function clearDateRange(assetId) {
  // Tarihi temizlediğimizde yine son 15 günlük veriyi gösterelim
  dateRange.value = {
    start: dayjs().subtract(14, "day").toDate(),
    end: dayjs().toDate(),
  };
  
  // Veriyi bu tarih aralığıyla yeniden getir
  fetchAnalyticsData(assetId);
}